.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.label {
  font-size: 14px;
  font-weight: 700;
}

.input {
  width: 100%;
  padding: 12px 14px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  font-size: 16px;
  line-height: 1.5;
  resize: vertical;
}

.input[aria-invalid='true'] {
  border-color: var(--error);
  box-shadow: 0 0 0 1px var(--error);
}

.error {
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}
